"use client";

import React from "react";
import Button from "../button";
import Pin from "../svg/pin";
import ArrowRight from "../svg/arrow-right";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface VacanciesItemProps {
    title: string;
    text: string;
    link: string;
}

const VacanciesItem: React.FC<VacanciesItemProps> = ({ title, text, link }) => {
    const pathname = usePathname();
    const isEn = pathname.startsWith("/en");

    return (
        <div className="flex justify-between items-center p-[40px] rounded-[32px] bg-white border-[1.5px] border-violet-50 max-[576px]:p-[20px] max-[576px]:flex-wrap max-[1200px]:gap-x-[10px]">
            {/* Left Section */}
            <div className="flex flex-col max-[576px]:w-full">
                <h3 className="text-[28px] font-bold text-black mb-[8px] max-[576px]:mb-0 max-[1200px]:text-[20px]">{title}</h3>
                <div className="flex items-center gap-[4px]">
                    <Pin />
                    <p className="text-[20px] text-violet-200 font-medium tracking-[0.02em] max-[576px]:text-[16px] max-[1200px]:text-[16px]">{text}</p>
                </div>
            </div>
            <Link href={link} className="max-[576px]:flex max-[576px]:w-full max-[576px]:mt-[16px]">
                <Button text={`${isEn ? "Read More" : "läs mer"}`} icon={<ArrowRight />} iconPostiton="right" type="primary" mobileFull="yes"/>
            </Link>
        </div>
    );
};

export default VacanciesItem;
